import axios from 'axios';

export function request(method: string, url: string, data: any, isLoader = true) {
    const reqObject = {
        method, url, data, isLoader
    };
    return axios(reqObject);
}

export function requestWithParam(method: string, url: string, data: any, params:any, isLoader = true) {
    const reqObject = {
        method, url, data, params,isLoader
    };
    return axios(reqObject);
}

export function upload(url: string, formData: FormData) {
    return axios.post(url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

export function downloadFile(url: string) {
    return axios.get(url, {
        responseType: 'blob',
    });
}
